import {
    GET_USERS_QUANTITY_REQUEST,
    GET_USERS_QUANTITY_SUCCESS,
    GET_USERS_QUANTITY_FAILURE,
} from '../constants/get_users_quantity.constants';

export const getUsersQuantityRequest = groupId => ({
    type: GET_USERS_QUANTITY_REQUEST,
    groupId,
});

export const getUsersQuantitySuccess = usersQuantity => ({
    type: GET_USERS_QUANTITY_SUCCESS,
    usersQuantity,
});

export const getUsersQuantityFailure = error => ({
    type: GET_USERS_QUANTITY_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/actions/get_users_quantity.actions.js